import React from 'react';
import PropTypes from 'prop-types';
import { reduce, get, map, size, filter, includes, has, keyBy } from 'lodash';
import { Form } from 'formik';
import * as Yup from 'yup';
import { Text, If, FlexContainer } from '../../../../../../components/common';
import UIStatusTable from '../../../../../../components/sections/Resume/UIStatusTable';
import { Query } from '../../../../../../components/graphql';
import { OrderAuditManagementConsumer } from '../../../../../../components/firebase/OrderAuditManagement';
import AuditHeaderInfo from './AuditHeaderInfo';
import { getColumns } from './AuditOrderTable';
import { withFirebase, withReloadable } from '../../../../../../hoc';
import WeightValidation from './WeightValidation';
import CallAndChatHistory from './components/CallAndChatHistory';
import PickingResult from './components/PickingResult';
import { formatRefId } from '../../../../../../utils/misc';
import GET_STOCK_BY_STORE_SKU from '../../../../../../queries/GET_STOCK_BY_STORE_SKU';
const { excessColumns, substituteColumns, parentColumns } = getColumns();

class AuditOrder extends React.Component {
    state = {
        formValues: {},
        wasSubmitted: {},
        firebase: {},
        pickingResultAllowed: false,
        callAndChatHistoryAllowed: false,
        currentStep: 0,
    };

    
    _renderTableItem = ({ auditInfo, ...ctx }, columns) => (item, index) => {
        const { orderId, orderSelected } = this.props;
        const status = get(item, 'picking.status');
        const parentProps = { orderId, storeId: get(orderSelected, 'idStore', null), auditInfo, onChangeValue: this.props.onChangeAudits, stockMap: get(columns, 'stockMap', {}), ...ctx }; // used to pass parent to atributes to children
        const hasExcess = has(item, 'picking.excess') && get(item, 'picking.excess') !== 0;

        const children = map(get(item, 'picking.substitution', []), (childrenItem) => {
            return {
                ...childrenItem,
                picking: { status: String(status).toLowerCase() },
                type: String(status).toLowerCase()
            };
        });

        const hasChildren = size(children);

        const _drawRowBorderBottom = (has, index, siz) => {
            if ((index === siz) && (has === false)) return '1px solid #eaeaea';
            if (has === 0) return '1px solid #eaeaea';
            if (has) return '1px dashed #eaeaea';
            return '1px solid transparent';
        };

        const buildRow = (tds, { width, ...item }, index, prefix = 'item', hasChildren, style = {}, childStyle = {}) => {
            const id = String(get(item, 'picking.productId', `${prefix}-${index}`));
            const excessStyle = prefix === 'excess' ? { borderBottomLeftRadius: 8, borderBottomRightRadius: 8, boxShadow: '0px 2px 4px 0px #00000026' } : {};
            const parentStyle = prefix === 'parent' ? { borderTopLeftRadius: 8, borderTopRightRadius: 8 } : {};

            return (<>
                {prefix === 'parent' && <tr colSpan='12' style={{ height: 8, backgroundColor: '#f4f4f4' }}></tr>}
                <tr key={`${prefix}-item-${id}`} className='test' style={{ ...style, backgroundColor: 'white', ...excessStyle, ...parentStyle }}>
                    {tds.map(({ dataIndex, columnStyle, render = () => (null) }, key) => {
                        return <td key={`${prefix}-item-${id}-child-${key}`}
                            style={{
                                borderBottom: _drawRowBorderBottom(hasChildren, index + 1, size(children)),
                                padding: 10,
                                fontSize: '11px',
                                maxWidth: '210px',
                                textAlign: [8, 9, 10, 11].includes(key) ? 'right' : 'left',
                                ...columnStyle,
                                ...childStyle
                            }}
                        >
                            {render({ ...item }, dataIndex, parentProps)}
                        </td>;
                    })}
                    {size(tds) === 11 && <td></td>}
                </tr>
            </>);
        };

        const row = [item].map((item, index) => buildRow(get(columns, 'parentColumns', []), item, index, 'parent', hasChildren));

        const tableChunk = [
            ...row,
            hasChildren ? children.map((item, index) => buildRow(get(columns, 'subsColumns', []), item, index, 'children', false)) : [],
            hasExcess ? buildRow(get(columns, 'excessColumns', []), item, index, 'excess', false, { backgroundColor: ' #f4f4f4' }, { padding: '3px 10px' }) : []
        ];

        return tableChunk;
    }

    _renderTableHeader = ({ title, width }, key) => (
        <th
            className=''
            key={`th-${key}`}
            style={{
                width,
                fontSize: '12px',
                textAlign: includes(['Producto', 'Resultado picking', 'Estado', 'Regla', 'Validación', 'Stock Disponible'], title) ? 'left' : 'right',
                verticalAlign: 'top',
                backgroundColor: '#E2E2E2',
                boxShadow: '0px -1px 0px 0px #00000033 inset'
            }}
            >
            { title }
        </th>
    )

    _getHeaderLabels = (columns) => columns.map(({ title, width }) => ({ title, width }))

    _filterItems = (response) => {
        const { items, auditInfo } = response;
        const invalidItems = map(get(auditInfo, 'results.failed'), ({ productId }) => productId);
        return filter(items, (orderItem) => {
            return includes(invalidItems, get(orderItem, 'picking.id')) || includes(['ADDED_BY_CLIENT'], get(orderItem, 'status'));
        });
    }

    _formGenerateValidationSchema = (fields) => {
        const items = filter(fields, ({ status }) => !includes(['ADDED_BY_CLIENT'], status));
        const _schema = reduce(items, (acc, item) => {
            const productId = get(item, 'picking.productId');
            return Object.assign(acc, {
                [productId]: Yup.object().shape({
                    value: Yup.string().required()
                })
            });
        }, {});
        return Yup.object().shape(_schema);
    }

    _getStepsHeader () {
        return (
            <FlexContainer style={{ minHeight: '40px' }} align='center'>
                <Text text='Validación de productos' size={15} strong={this.state.currentStep === 0} paddingVertical={15} />
            </FlexContainer>
        );
    }

    componentWillUnmount () {
        if (this._salesChannelUnsub) this._salesChannelUnsub();
        this.props.toggleAudit(false);
    }

    async componentDidMount () {
        await this.props.toggleAudit(true);

        this._salesChannelUnsub = this.props.firebase
            .collection('salesChannel')
            .doc(this.props.orderSelected.salesChannel.id)
            .onSnapshot(doc => {
                this.setState({
                    callAndChatHistoryAllowed: get(doc.data(), 'callAndChatHistory', false),
                    pickingResultAllowed: get(doc.data(), 'pickingResult', false)
                });
            });
    }

    render () {
        const { orderId, data, orderSelected } = this.props;
        const salesChannelId = get(orderSelected, 'salesChannel.id');
        const storeId = get(orderSelected, 'idStore', null);
        const filteredItems = this._filterItems(data);
        const refIds = map(filteredItems, (item) => formatRefId(get(item, 'refId', ''))) || [];
        return (
            <FlexContainer direction='column' flex={1}>
                <If condition={this.state.currentStep === 0} then={(
                    <FlexContainer direction='column' width='100%' display='block' >
                        <AuditHeaderInfo orderId={orderId} dataParent={data} />
                        <CallAndChatHistory
                            callAndChatHistoryAllowed={this.state.callAndChatHistoryAllowed}
                            orderId={orderId}
                            isWhatsapp={get(data, 'isWhatsapp', false)}
                        />
                        <PickingResult
                            pickingResultAllowed={this.state.pickingResultAllowed}
                            orderId={orderId}
                            data={data}
                            salesChannelId={salesChannelId}
                        />
                        
                        <Form>
                            <FlexContainer direction='column' flex={1}>
                                <FlexContainer direction='column' grow={1} mB={100}>
                                    <If
                                        condition={this.props.firstAudit}
                                        then={
                                            <WeightValidation
                                                weightError={this.props.weightError}
                                                semaphore={this.props.semaphore}
                                                callback={() => this.props.setWeightValidation()}
                                            />
                                        }
                                    />
                                    {this._getStepsHeader()}
                                    {size(refIds) > 0 && (
                                        <Query
                                            query={GET_STOCK_BY_STORE_SKU}
                                            variables={{ storeId, refIds }}
                                        >
                                            {({ data: stockData }) => {
                                                const stockMap = keyBy(get(stockData, 'getStockByStoreAndSKU.data', []), (item) => formatRefId(get(item, 'matnr', '')));
                                                return (
                                                    <UIStatusTable
                                                        className='default-table'
                                                        tableProps={{ className: 'order-items-table' }}
                                                        renderItem={this._renderTableItem(data, {
                                                            parentColumns: parentColumns,
                                                            subsColumns: substituteColumns,
                                                            excessColumns,
                                                            stockMap
                                                        })}
                                                        renderHeader={this._renderTableHeader}
                                                        headers={this._getHeaderLabels(parentColumns)}
                                                        data={filteredItems}
                                                    />
                                                );
                                            }}
                                        </Query>
                                    )}

                                </FlexContainer>
                            </FlexContainer>
                        </Form>
                    </FlexContainer>
                )} />
            </FlexContainer>
        );
  }
}

AuditOrder.propTypes = {
    weightError: PropTypes.bool,
    firstAudit: PropTypes.bool,
    loading: PropTypes.bool,
    data: PropTypes.object,
    orderId: PropTypes.string,
    firebase: PropTypes.object,
    onChangeAudits: PropTypes.func,
    toggleAudit: PropTypes.func,
    orderSelected: PropTypes.object
};

AuditOrder.defaultProps = {
    onChangeAudits: () => {},
    toggleAudit: () => {}
};

export default withReloadable(withFirebase((props) => (
    <OrderAuditManagementConsumer orderId={get(props, 'orderId')}>
        {({ toggleAudit }) => (
            <AuditOrder {...props} toggleAudit={toggleAudit} />
        )}
    </OrderAuditManagementConsumer>
), ['orderId']));
